/** Miles → kilometers for display and schedule parsing (user-specified factor). */
export const MI_TO_KM = 1.60934;
